import gql from "graphql-tag"
import { signOut } from "firebase/auth"
import { AppThunkAction } from "../store/configureStore"
import { setImpersonation } from "../utils/users"
import apolloClientNext, { clearSessionCookie } from "../ApolloClientNext"
import { setIncludePrivate } from "./searchActions"
import { sdk9Auth } from "../firebase"
import { SignOutDocument } from "./userActions.graphqlTypes"
import {
  RESET_USER_STATE,
  RESET_ADMIN_STATE,
  RESET_INSTRUCTOR_STATE,
  RESET_CART_STATE,
  RESET_COURSES_STATE,
  RESET_SEARCH,
  DE_PACKAGE_RESET,
  RESET_BOOKING_STATE,
  RESET_PROFILE_AUTH,
} from "./types"

gql`
  mutation SignOut {
    signOut
  }
`

export const clearReduxPersist = (): void => {
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i)
    if (key && key.startsWith("persist:")) {
      localStorage.removeItem(key)
    }
  }

  for (let i = sessionStorage.length - 1; i >= 0; i--) {
    const key = sessionStorage.key(i)
    if (key && key.startsWith("persist:")) {
      sessionStorage.removeItem(key)
    }
  }
}

export const clearFirebaseStorage = (): void => {
  // Don't clear Firebase storage that maintains the auth state connection
  // The signOut() method from Firebase will properly clear user-specific data
  // while preserving the infrastructure needed for future auth state changes

  // Only clear non-essential Firebase keys, preserve auth infrastructure
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i)
    if (key && key.includes("firebase") && !key.includes("firebase:authUser")) {
      // Clear cache and temporary data, but preserve auth state infrastructure
      if (key.includes("cache") || key.includes("temp")) {
        localStorage.removeItem(key)
      }
    }
  }
}

export const clearOtherStorage = (): void => {
  setImpersonation(undefined)
  localStorage.removeItem("impersonated")
  sessionStorage.removeItem("impersonated")
}

export const resetAllReduxState = (): AppThunkAction => {
  return (dispatch) => {
    dispatch({ type: RESET_USER_STATE })
    dispatch({ type: RESET_ADMIN_STATE })
    dispatch({ type: RESET_INSTRUCTOR_STATE })
    dispatch({ type: RESET_CART_STATE })
    dispatch({ type: RESET_COURSES_STATE })
    dispatch({ type: RESET_SEARCH })
    dispatch({ type: DE_PACKAGE_RESET })
    dispatch({ type: RESET_BOOKING_STATE })
    dispatch({ type: RESET_PROFILE_AUTH })
  }
}

export const clearAllStorage = (): void => {
  clearReduxPersist()
  clearFirebaseStorage()
  clearOtherStorage()
}

export const handleSignout = (): AppThunkAction => async (dispatch) => {
  dispatch(resetAllReduxState())
  dispatch(setIncludePrivate(false))

  await apolloClientNext.mutate({ mutation: SignOutDocument })
  clearSessionCookie()

  await signOut(sdk9Auth)

  clearAllStorage()
}
